import { createContext, useContext } from 'react';

/**
 * Creates a React context with a safe hook that throws if used outside its provider.
 *
 * Usage:
 *   const [MyContext, useMyContext] = createSafeContext<MyValue>('MyContext');
 */
export function createSafeContext<T>(displayName: string): [React.Context<T | null>, () => T] {
  const Context = createContext<T | null>(null);
  Context.displayName = displayName;

  const useContextHook = (): T => {
    const value = useContext(Context);
    if (value === undefined || value === null) {
      throw new Error(`use${displayName.replace('Context', '')} must be used within a ${displayName.replace('Context', '')}Provider`);
    }
    return value;
  };

  return [Context, useContextHook];
}
